import axios from 'axios';
import aplicacionesApi from './aplicaciones';
import { safeLocalStorage, safeSessionStorage } from 'legacyfrontend/helpers/ssr-helper';
/* eslint-disable */
export default {
  async getToken() {
    const { hostname } = window.location;
    return aplicacionesApi
      .obtenerAplicacion(hostname)
      .then((res) => res.access_token)
      .catch((res) => {
        if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') {
          safeSessionStorage.setItem(`[TOKEN][${new Date()}]`, JSON.stringify(res));
        }
        return '';
      });
  },
  async obtenerDestinos() {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${safeLocalStorage.getItem('token')}`,
      },
    };

    const response = await axios.get(`${process.env.RAZZLE_API_GEO}/destinos/`, config);
    return response.data;
  },
  async obtenerOrigenes() {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${safeLocalStorage.getItem('token')}`,
      },
    };

    const response = await axios.get(`${process.env.RAZZLE_API_GEO}/origenes/`, config);
    return response.data;
  },
  async obtenerPaquetesOfertas() {
    await aplicacionesApi.obtenerAplicacion('mundigea');
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${safeLocalStorage.getItem('token')}`,
      },
    };
    try {
      const response = await axios
        .get(`${process.env.RAZZLE_API_PAQUETES}/paquetes/obtener-ofertas`, config);
      return response;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error al obtener las ofertas: ${error?.response?.data}`);
      throw new Error(`${error?.response?.data?.message}`);
    }
  },
  async getOrigins(token) {
    const appToken = await this.getToken();
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${appToken}`,
      },
    };
    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/package/origins`,
        config
      );
      return res.data;
    } catch (e) {
      console.error(`Error al obtener las ciudades de origen: ${e?.response?.data}`);
      throw new Error(e?.response?.data?.message);
    }
  },
  async getDestinations(originId, token) {
    const appToken = await this.getToken();
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${appToken}`,
      },
    };
    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/package/destinations?originId=${originId}`,
        config
      );
      return res.data;
    } catch (e) {
      console.error(`Error al obtener las ciudades de destino: ${e?.response?.data}`);
      throw new Error(`${e?.response?.data?.message}`);
    }
  },
  async getAirportSuggestions(kind = '') {
    const authToken = await this.getToken();

    if (!authToken) {
      throw new Error('No se pudo obtener el token de autenticación');
    }

    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${authToken}`,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
      },
      params: {
        ...(kind ? { kind } : {}),
        _t: Date.now(),
      },
    };

    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/airport/suggestions`,
        config
      );
      return res.data;
    } catch (e) {
      throw new Error(e?.response?.data?.message);
    }
  },
  async getAirports(filters = {}, token) {
    const authToken = token || await this.getToken();

    if (!authToken) {
      throw new Error('No se pudo obtener el token de autenticación');
    }

    const { cityName, search, ...restFilters } = filters;
    const searchParam = search !== undefined && search !== null ? search : cityName;

    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${authToken}`,
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
      },
      params: {
        ...restFilters,
        ...(searchParam !== undefined && searchParam !== null && String(searchParam).trim() !== ''
          ? { search: String(searchParam).trim() }
          : {}),
        _t: Date.now(),
      },
    };

    try {
      const res = await axios.get(`${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/airport/search`, config);
      return res.data;
    } catch (e) {
      throw new Error(e?.response?.data?.message);
    }
  },
  async getAirportById(id, token) {
    const authToken = token || await this.getToken();

    if (!authToken) {
      throw new Error('No se pudo obtener el token de autenticación');
    }

    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
    };

    try {
      const res = await axios.get(`${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/airport/${id}`, config);
      return res.data;
    } catch (e) {
      throw new Error(`Error fetching airport, id: ${id}: ${e?.response?.data?.message}`);
    }
  },
  async fetchLlegoData(filters = {}, token) {
    const authToken = token || await this.getToken();

    if (!authToken) {
      throw new Error('No se pudo obtener el token de autenticación');
    }

    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
    };

    try {
      const res = await axios.post(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/llego`,
        filters,
        config
      );
      return res.data;
    } catch (error) {
      if (error.name !== 'AbortError' && error.code !== 'ERR_CANCELED') {
        const errorDetails = error?.response?.data || error?.message || 'Error desconocido';
        console.error('Error al obtener los datos de llegada:', errorDetails);
      }

      throw error;
    }
  },
  async getLlegoFlightDetails(params = {}, token) {
    const authToken = token || await this.getToken();

    if (!authToken) {
      throw new Error('No se pudo obtener el token de autenticación');
    }

    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      params,
    };

    try {
      const res = await axios.get(`${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/llego`, config);
      return res.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Error interno del servidor';
      console.error(`Error al obtener los detalles del vuelo: ${errorMessage}`);
      throw new Error(`No pudimos obtener los detalles del vuelo: ${errorMessage}`);
    }
  },
  async getLlegoPricing(params = {}, token) {
    const authToken = token || await this.getToken();

    if (!authToken) {
      throw new Error('No se pudo obtener el token de autenticación');
    }

    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      params,
    };

    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/llego/pricing`,
        config
      );
      return res.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Error interno del servidor';
      console.error(`Error al obtener las tarifas del vuelo: ${errorMessage}`);
      throw new Error(`No pudimos obtener las tarifas del vuelo: ${errorMessage}`);
    }
  },
  async getLlegoStandalone(params = {}, token) {
    const authToken = token || await this.getToken();

    if (!authToken) {
      throw new Error('No se pudo obtener el token de autenticación');
    }

    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      params,
    };

    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/llego/stand-alone-catalogue`,
        config
      );
      return res.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Error interno del servidor';
      console.error(`Error al obtener el catálogo de vuelos: ${errorMessage}`);
      throw new Error(`No pudimos obtener el catálogo de vuelos: ${errorMessage}`);
    }
  },
  async createBooking(data = {}, token) {
    if (!token) {
      throw new Error('No se pudo obtener el token de autenticación');
    }

    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const res = await axios.post(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/llego/booking`,
        data,
        config
      );
      return res.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Error interno del servidor';
      console.error(`Error al crear la reserva de vuelo: ${errorMessage}`);
      throw new Error(`No pudimos crear la reserva de vuelo: ${errorMessage}`);
    }
  },
  async sendMail(data = {}, token) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const res = await axios.post(
        `${process.env.RAZZLE_API_MARCA_BLANCA}/booking-notification/send-mail`,
        data,
        config
      );
      return res.data;
    } catch (error) {
      console.error(`Error al enviar el mail: ${error?.response?.data}`);
      throw new Error(`No pudimos enviar el mail: ${error?.response?.data?.message}`);
    }
  },
  async getPackages(query) {
    const config = {
      headers: {
        'Content-type': 'application/json',
      },
    };
    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/hotel-information${query}`,
        config
      );
      return res.data;
    } catch (e) {
      console.error(`Error al obtener los paquetes: ${e?.response?.data}`);
      throw new Error(`${e?.response?.data?.message}`);
    }
  },
  async getAvailableDates(query) {
    const appToken = await this.getToken();
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${appToken}`,
      },
    };
    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/package/closest-package?originId=${query.originId}&destinationId=${query.destinationId}`,
        config
      );
      return res.data;
    } catch (e) {
      console.error(`Error al obtener las fechas disponibles: ${e?.response?.data}`);
      throw new Error(`${e?.response?.data?.message}`);
    }
  },
  async getPackagesV2(query) {
    const appToken = await this.getToken();
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${appToken}`,
      },
    };
    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/package${query}`,
        config
      );
      return res.data;
    } catch (e) {
      console.error(`Error al obtener los paquetes: ${e?.response?.data}`);
      throw new Error(`${e?.response?.data?.message}`);
    }
  },
  async getPackageDetail(packageId) {
    const appToken = await this.getToken();
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${appToken}`,
      },
    };
    try {
      const res = await axios.get(
        `${process.env.RAZZLE_API_PACKAGE_PROVIDERS}/package/${packageId}`,
        config
      );
      return res.data;
    } catch (e) {
      console.error(`Error al obtener el detalle del paquete: ${e?.response?.data}`);
      throw new Error(`${e?.response?.data?.message}`);
    }
  },
  async getInternalPackage(packageId, token, salidaId = null) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      let url = `${process.env.RAZZLE_API_PACKAGE_REGIONAL}/paquetes/salida?id=${packageId}`;
      if (salidaId) {
        url += `&salidaId=${salidaId}`;
      }

      const res = await axios.get(url, config);
      return res.data;
    } catch (e) {
      console.error(`Error al obtener el paquete: ${e?.response?.data}`);
      throw new Error(`${e?.response?.data?.message}`);
    }
  },
  async getInternalPackageSalidas(paqueteId, monthYear, token, adultsQty = null) {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      params: {
        paqueteId,
        monthYear,
      },
    };

    if (adultsQty && adultsQty > 0) {
      config.params.baseType = adultsQty;
    }

    try {
      const res = await axios.get(`${process.env.RAZZLE_API_PACKAGE_REGIONAL}/paquetes/dates`, config);
      return res.data;
    } catch (e) {
      console.error(`Error al obtener las salidas: ${e?.response?.data}`);
      throw new Error(`${e?.response?.data?.message}`);
    }
  }
};
